import NotFound from 'pages/NotFound';
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { agentRoutes } from './agentRoutes';
import { landlordRoutes } from './landlordRoutes';
import { tenantRoutes } from './tenantRoutes';

/**
 * Defines the main application routes using React Router.
 * Combines tenant and agent routes into a single router configuration.
 *
 * @returns The router component containing all application routes.
 */
const AppRoutes: React.FC = () => (    
    <Routes>
        {tenantRoutes}
        {agentRoutes}
        {landlordRoutes}
        <Route path="*" element={<NotFound />} />
    </Routes>
);

export default AppRoutes;